import React, { useEffect, useState, useRef } from 'react';
import BasicInput from '../../TcIndex/Basic/BasicInput';
import { CircularProgress, TableRowColumn } from 'material-ui';
import { s } from '../HiresTableRow';
import api from 'services';

/**
 * Converts a date string to yyyy-mm-dd format
 * @param {string | Date} dateString - The date string to convert
 * @returns {string} - The formatted date
 */
const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    
    // no need to provide date if it's today
    if (date.toISOString().split('T')[0] === today.toISOString().split('T')[0]) {
        return undefined;
    }
    
    return date.toISOString().split('T')[0];
};

/**
 * @param {{
 *  fuelPrice: FuelPrice,
 *  countIndex: number,
 *  changeFieldsMultiple: Function,
 *  lay: Date,
 *  bunkerPlace: any,
*   mainRegionDelivery: any
 * }} param0 
 * @returns 
 */
export const FuelPrice = ({
    fuelPrice, changeFieldsMultiple, countIndex, lay, bunkerPlace, mainRegionDelivery,
}) => {
    const [selectedFuelType, setSelectedFuelType] = useState(null);
    const hasMounted = useRef(false); // need that to prevent price call on first render
    const [fuelPriceLoading, setFuelPriceLoading] = useState(false);

    const updatePricesInStore = (value) => {
        changeFieldsMultiple([
            { index: countIndex, field: 'fuelPrice', value },
            { index: countIndex, field: 'mainRegionDelivery', value: mainRegionDelivery },
            ...(!bunkerPlace ? [{ index: countIndex, field: 'bunkerPlace', value: mainRegionDelivery }] : []),
        ]);
    };
    
    const pickCurrentFuelPrice = (_fuelPrice) => {
        const { ifo380, mgo, vlsfo } = _fuelPrice || {};
        if (vlsfo) {
            setSelectedFuelType('vlsfo');
        } else if (ifo380) {
            setSelectedFuelType('ifo380');
        } else if (mgo) {
            setSelectedFuelType('mgo');
        } else {
            setSelectedFuelType(null);
        }
    };

    useEffect(() => {
        pickCurrentFuelPrice(fuelPrice);
    }, [fuelPrice]);

    useEffect(() => {
        const fetchFuelPrice = async () => {
            const portId = bunkerPlace && bunkerPlace._id;
            if (portId) {
                setFuelPriceLoading(true);
                await api.fuel.getFuelPriceFilteredV2({ 
                    date: formatDate(lay),
                    entityId: portId,
                    isArea: !!bunkerPlace.areaParent,
                }).then((res) => {
                    if (res.data && (!res.errors || (res.errors && !res.errors.length))) {
                        let dataToUpdate;

                        // Check if fuelPrices is a string "Fuel price not found" or not a valid object
                        if (res.data.fuelPrice === 'Fuel price not found' || 
                            typeof res.data.fuelPrice !== 'object' || 
                            res.data.fuelPrice === null
                        ) {
                            // Check if averageFuelPricesByChilds exists and is an object
                            if (res.data.averageFuelPricesByChilds && 
                                typeof res.data.averageFuelPricesByChilds === 'object'
                            ) {
                                // Use averageFuelPricesByChilds instead
                                dataToUpdate = res.data.averageFuelPricesByChilds;
                            }
                        } else {
                            // Use fuelPrice if it's a valid object
                            dataToUpdate = res.data.fuelPrice;
                        }

                        updatePricesInStore(dataToUpdate);
                    }
                }).finally(() => setFuelPriceLoading(false));
            }
        };

        if (hasMounted.current) {
            fetchFuelPrice();
        } else {
            hasMounted.current = true;
        }
    }, [lay, bunkerPlace]);

    useEffect(() => {
        pickCurrentFuelPrice(fuelPrice);
    }, []);
    
    const handleInputChange = (e) => {
        const newValue = e.target.value;
        updatePricesInStore({
            vlsfo: newValue ? parseFloat(newValue) : undefined,
        });
    };

    return (
        <React.Fragment>
            <TableRowColumn style={{ ...s.small, textAlign: fuelPriceLoading ? 'center' : 'unset' }}>
                { 
                    fuelPriceLoading ? <CircularProgress size={16} /> 
                        : <BasicInput 
                            name='fuelPriceValue'
                            value={fuelPrice && (fuelPrice[selectedFuelType] || '')}
                            placeholder="-"
                            onFocus={e => e.target.placeholder = ''}
                            onBlur={e => e.target.placeholder = '-'}
                            onChange={handleInputChange}
                            floatingLabelStyle={{ display: 'none' }}
                            underlineStyle={{ display: 'none' }}
                            style={{ fontSize: '9px' }}
                            type='number'
                        />
                }
            </TableRowColumn>
        </React.Fragment>
    );
};

export default React.memo(FuelPrice);

/**
 * @typedef {Object} FuelPrice
 * @property {number} [ifo380]
 * @property {number} [mgo]
 * @property {number} [vlsfo]
 */



// WEBPACK FOOTER //
// ./app/components/Hires/rowData/FuelPrice.jsx